var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-loading',{attrs:{"type":"balls","color":"rgb(243, 165, 170)","size":{ width: _vm.size, height: _vm.size }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }